import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React, { useId } from "react";

export function TikTokIcon(props: IconProps) {
  const id = useId();

  return (
    <Icon fill="none" viewBox="0 0 24 24" {...props}>
      <Box as="g" clipPath={`url(#tiktok-${id}-a)`}>
        <Box
          as="path"
          fill="#160C1A"
          fillRule="evenodd"
          d="M5.42 0h13.16a5.423 5.423 0 0 1 3.828 1.6A5.474 5.474 0 0 1 24 5.444v13.112a5.474 5.474 0 0 1-1.593 3.844A5.423 5.423 0 0 1 18.58 24H5.42a5.423 5.423 0 0 1-3.827-1.599A5.474 5.474 0 0 1 0 18.557V5.445A5.474 5.474 0 0 1 1.592 1.6 5.423 5.423 0 0 1 5.42 0Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#26F4EE"
          fillRule="evenodd"
          d="M15.15 2.955c.291 2.498 1.782 4.26 4.186 4.417V9.74 7.73c-2.42-.156-3.805-1.647-4.102-4.143h-2.539v10.508c.37 4.73-3.299 4.872-4.703 3.078 1.637 1.035 4.313.361 3.992-3.708V2.955h3.166ZM8.291 20.378a5.398 5.398 0 0 1-3.525-2.431c-1.872-3.075-.184-8.089 5.244-8.605v.74c-5.041.806-5.547 6.236-4.15 8.496a4.32 4.32 0 0 0 2.433 1.8H8.29Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#FB2C53"
          fillRule="evenodd"
          d="M15.877 3.74c.166 1.423.687 2.659 1.549 3.49-1.215-.63-1.942-1.826-2.172-3.49h.623Zm3.445 4.501c.212.046.427.076.643.089v2.8c-1.399.14-2.623-.324-4.049-1.178l.219 4.804c0 1.55 0 2.259-.823 3.687-2.019 3.477-5.79 3.475-8.025 1.495 2.912 1.68 7.996.365 7.986-5.341V9.348c1.426.861 2.65 1.323 4.05 1.177V8.241Zm-9.326 2.023a8.44 8.44 0 0 1 .922-.139v2.963c-1.172.196-1.922.557-2.272 1.226-.976 1.89.045 3.428 1.407 3.925-1.703-.063-3.39-1.82-2.219-4.072.35-.67.977-1.032 2.162-1.228v-2.675Z"
          clipRule="evenodd"
        />
        <Box
          as="path"
          fill="#fff"
          fillRule="evenodd"
          d="M15.234 3.581c.291 2.502 1.678 3.99 4.088 4.144v2.808c-1.398.138-2.623-.323-4.049-1.177v5.241c.012 6.852-7.324 7.38-9.414 3.976-1.392-2.26-.886-7.69 4.145-8.495v2.851c-1.172.196-1.813.557-2.162 1.229-2.149 4.144 5.367 6.61 4.847-.067V3.58h2.545Z"
          clipRule="evenodd"
        />
      </Box>
      <Box as="defs">
        <clipPath id={`tiktok-${id}-a`}>
          <Box as="path" fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </Box>
    </Icon>
  );
}
